import { Caption, Flex, useStyles } from '@archipro-design/aria';
import * as S from './ImageCaption.style';
import parse from 'html-react-parser';
import { cn } from '@rocco/utils/cn';

interface ImageCaptionProps {
    text: string;
    isMain?: boolean;
    moduleType?: string;
    isProject?: boolean;
    fullScreen?: boolean | null;
    inViewPort?: boolean;
    isPageBuilder?: boolean;
}

const ImageCaption = ({
    text,
    isMain,
    moduleType,
    isProject,
    fullScreen,
    inViewPort,
    isPageBuilder,
}: ImageCaptionProps) => {
    const { css } = useStyles({
        moduleType,
        isProject,
        fullScreen,
        inViewPort,
        isPageBuilder,
    });
    const captionStyle = isMain
        ? S.TagMainCaptionContainer
        : S.TagSubCaptionContainer;
    const captionAsReactElements = parse(text);

    return (
        <Flex className={cn(css(captionStyle), '!font-display !font-[400]')}>
            <Caption variant="03-alt">{captionAsReactElements}</Caption>
        </Flex>
    );
};

export default ImageCaption;
